// ===========================================================================
// 保存の照合が外れた（開いたあとに他の人が保存していた）
// ===========================================================================
// フォーム項目の保存（form.js の updateItems に base_items_hash を渡したとき）で
// サーバ（cms の api/saver/form/form_items_hash.go）が返す U000132 を表す。
// テンプレート本文の保存（template.js の update* に base_source_hash を渡したとき。
// cms の api/saver/template/source_hash.go）も同じコードで、template-source-conflict.js。
// 管理画面設定の同じ意味のエラーは admin-config-conflict.js。
//
// ⚠ 依存の無いモジュールしか import しない（受ける側が axios まで読み込まずに済むように）。

import { ADMIN_CONFIG_CONFLICT_CODE } from './admin-config-conflict';

// cms のセーバー（ErrSaveConflict）・cms-client-admin と同じ値。
export const SAVE_CONFLICT_CODE = ADMIN_CONFIG_CONFLICT_CODE;

export class FormItemsConflictError extends Error {
    constructor() {
        super('他の人がこのフォームの項目を保存しています');
        this.name = 'FormItemsConflictError';
        this.conflict = true;
    }
}

/** 応答本文（{status, error}）が照合の外れか。 */
export function isSaveConflictBody(body) {
    return !!body?.error
        && typeof body.error === 'object'
        && Object.prototype.hasOwnProperty.call(body.error, SAVE_CONFLICT_CODE);
}
